import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'fileName'
})
export class FileNamePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '-';
    return value.split('/').pop() || value;
  }
}